// extracted by mini-css-extract-plugin
module.exports = {"baseSectionMessage":"baseSectionMessage--vEToP","message":"message--YPfNB","button":"button--zTgjN"};